exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".gaugeChart{color:red}.no-data{font-size:20px;height:300px;display:flex;flex-direction:column;align-items:center;justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/components/common/gaugeChart/gaugeChart.styl
// module id = 1326
// module chunks = 0